document.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.querySelectorAll('.collapsible-row-pro__details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (details.open) return;

      const row = details.closest('.collapsible-row-pro');
      if (!row || typeof row.animate !== 'function') return;

      row.animate(
        [
          { transform: 'translateY(0)', offset: 0 },
          { transform: 'translateY(-4px)', offset: 0.45 },
          { transform: 'translateY(1px)', offset: 0.75 },
          { transform: 'translateY(0)', offset: 1 },
        ],
        { duration: 400, easing: 'ease-out' }
      );
    });
  });
});
